export enum DashboardMode {
  Default = 'default',
  Selection = 'selection'
}



// WEBPACK FOOTER //
// ./src/shared/enum/dashboardMode.ts